import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-contact',
  templateUrl: './breadcrumb-contact.component.html',
  styleUrls: ['./breadcrumb-contact.component.scss']
})
export class BreadcrumbContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
